import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { map } from "rxjs/operators";
import { AccessListService } from "../../services/access-list.service";

declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {
    accessData: any[] = [];

    //Menu Start
    menuMasterSetup = false;
    menuEmployee = false;
    menuPayStructure = false;
    menuLeave = false;
    menuAttendance = false;
    menuAdvancePayment = false;
    menuOverTime = false;
    menuPresentOffday = false;
    menuNightStay = false;
    menuReport = false;
    menuAccounting = false;
    menuCostCenterSetup = false;
    menuProjectAccess = false;
    menuIncomeTax = false;
    menuProvidentFund = false;

    //SubMenu Start

    // sub-menu for master setup
    submenuGroupSetup = false;
    submenuCompanySetup = false;
    submenuCompanyList = false;
    submenuBusinessUnitList = false;
    submenuBusinessUnitSetup = false;
    submenuDesignationSetup = false;
    submenuDesignationList = false;
    submenuEquivalentDesignationSetup = false;
    submenuEquivalentDesignationList = false;
    submenuDepartmentSetup = false;
    submenuDepartmentList = false;
    submenuGradeSetup = false;
    submenuGradeList = false;
    submenuPrefixSetup = false;
    submenuPrefixList = false;
    submenuShiftSetup = false;
    submenuShiftList = false;
    submenuCostCenterList = false;
    submenuCountryList = false;
    submenuBankList = false;
    submenuBranchBankSetup = false;
    submenuBranchBankList = false;
    submenuWorkStationSetup = false;
    submenuWorkStationList = false;
    submenuEmployeeNatureTypeSetup = false;
    submenuEmployeeNatureTypeList = false;
    submenuWeekendSetup = false;
    submenuLeaveYearSetup = false;
    submenuCalendarSetup = false;
    submenuAbsentTemplate = false;
    submenuAbsentTemplateList = false;
    submenuAbsentSetup = false;
    submenuHolidayTypeSetup = false;
    submenuHolidaySetup = false;
    submenuHolidayList = false;
    submenuDenominationMaster = false;
    submenuDenominationList = false;
    submenuOvertimeTemplateSetup = false;
    submenuOvertimeTemplateSetupList = false;
    submenuPresentOffdayTemplateSetup = false;
    submenuPresentOffdayTemplateList = false;
    submenuNightStayTemplateSetup = false;
    submenuNightStayTemplateList = false;
    submenuProjectWiseTemplateAssign = false;
    submenuProvidentFundTemplateSetup = false;
    submenuProvidentFundTemplateList = false;
    submenuFiscalYearList = false;

    submenuEducationConcentration = false;
    submenuEducationBoardMaster = false;
    submenuEducationBoardList = false;
    submenuEducationLevelMaster = false;
    submenuEducationLevelList = false;
    submenuEducationInstituteMaster = false;
    submenuEducationInstituteList = false;
    submenuEducationExamTitleMaster = false;
    submenuEducationExamTitleList = false;

    // sub-menu for emplyee
    submenuPersonal = false;
    submenuEducationInfo = false;
    submenuExperienceInfo = false;
    submenuEmployeeList = false;
    submenuInsertEmployeeExcel = false;
    submenuOrganizationSetup = false;
    submenuOrganizationList = false;
    submenuEmployeeTransfer = false;
    submenuTransferList = false;
    submenuEmployeeContractRenew = false;
    submenuOrganizationSetupExcel = false;
    submenuUpdateEmployeeExcel = false;
    submenuEducationInfoExcel = false;
    submenuExperienceInfoExcel = false;
    submenuTrainingCertificationInfo = false;
    submenuEmployeePromotion = false;
    submenuPromotionList = false;
    submenuEmployeeRemarks = false;
    submenuEmployeeRemarksList = false;

    // sub-menu for pay-structure
    submenuEarningHeads = false;
    submenuEarningHeadsList = false;
    submenuDeductionHeads = false;
    submenuDeductionHeadsList = false;
    submenuPayStructureTemplate = false;
    submenuTemplateList = false;
    submenuPayStructureSetup = false;
    submenuPayStructureList = false;
    submenuBonusSetup = false;
    submenuBonusListEmployee = false;
    submenuBonusListProject = false;
    submenuVariableInput = false;
    submenuVariableInputList = false;
    submenuHoldingHeadEntry = false;
    submenuHoldingHeadList = false;
    submenuPaySlipGeneration = false;
    submenuFinalSettlement = false;
    submenuFinalSettlementList = false;
    submenuSupplimentarySalary = false;
    submenuSupplimentarySalaryList = false;
    submenuManPowerBudget = false;
    submenuManPowerBudgetList = false;
    submenuPayStructureSetupExcel = false;
    submenuPayStructureResignedList = false;

    // sub-menu for leave
    submenuLeaveTypeSetup = false;
    submenuLeaveTypeList = false;
    submenuLeavePolicySetup = false;
    submenuLeavePolicyList = false;
    submenuRegularLeaveBalanceImport = false;
    submenuMonthlyLeaveBalanceImport = false;
    submenuLeaveApplication = false;
    submenuLeaveApplicationExcel = false;
    submenuLeaveApplicationList = false;
    submenuLeaveEncashmentSetup = false;
    submenuLeaveEncashmentSetupList = false;
    submenuLeaveEncashmentGeneration = false;
    submenuLeaveEncashmentHistory = false;

    // sub-menu for attendance
    submenuAttendanceEntryCalendar = false;
    submenuAttendanceHistory = false;
    submenuAttendanceEntryExcelImport = false;
    submenuAttendanceHistoryFromDevice = false;
    submenuAttendanceCalculation = false;
    submenuLatePresentSetup = false;
    submenuOutstationEntry = false;

    // sub-menu for advance
    submenuAdvanceTemplateSetup = false;
    submenuAdvanceTemplateSetupList = false;
    submenuAdvancePayment = false;
    submenuAdvanceHistory = false;
    submenuMonthlyAdvanceDeduction = false;
    submenuEarlySettlement = false;

    // sub-menu for overtime
    submenuOvertimeSetup = false;
    submenuOvertimeSetupList = false;
    submenuOvertimeEntry = false;
    submenuOvertimeHistory = false;
    submenuMonthlyOvertimeEntry = false;
    submenuMonthlyOvertimeEntryList = false;

    // sub-menu for present-offday
    submenuPresentOffDaySetup = false;
    submenuPresentOffDayList = false;
    submenuMonthlyPOEntry = false;
    submenuMonthlyPOList = false;
    submenuOffdayPresent = false;
    submenuOffdayPresentList = false;

    // sub-menu for night-stay
    submenuNightStaySetup = false;
    submenuNightStaySetupList = false;
    submenuMonthlyOSEntry = false;
    submenuMonthlyOSList = false;

    // sub-menu for Provident Fund
    submenuProvidentFundSetup = false;
    submenuProvidentFundSetupList = false;

    // sub-menu for report
    submenuEmployeeReport = false;
    submenuSetupReport = false;
    submenuEntryReport = false;
    submenuAttendanceReport = false;
    submenuHabitualReport = false;
    submenuOverallReport = false;
    submenuCentralReport = false;
    submenuSalaryTdsReport = false;
    submenuPersonalEmployeeListReport = false;
    submenuOrganizationListReport = false;
    submenuPayStructureListReport = false;
    submenuPaySlipListEmployee = false;
    submenuPaySlipListMonthly = false;
    submenuPaySlipListWorkStation = false;
    submenuSalaryStatementForBank = false;
    submenuSalaryStatementForCash = false;
    submenuVariableInputListReport = false;
    submenuLeavePolicyListReport = false;
    submenuLeaveBalanceListReport = false;
    submenuLeaveReportDetails = false;
    submenuLeaveReportSummary = false;
    submenuLeaveEncashmentSetupListReport = false;
    submenuOvertimeReport = false;
    submenuAdvanceHistoryReport = false;
    submenuEarlySettlementReport = false;
    submenuHolidayListReport = false;
    submenuPresentOffDayListReport = false;
    submenuTransferListReport = false;
    submenuDenominationReport = false;
    submenuCommonReport = false;
    submenuProjectwiseAllEmployeeList = false;
    submenuSalaryHoldupEmployeeList = false;
    submenuAttritionReport = false;
    submenuChartReport = false;
    submenuBonusListReport = false;
    submenuBonusStatementForBank = false;
    submenuBonusStatementForCash = false;
    submenuProvidentFundReport = false;
    submenuRemarksReport = false;

    // sub-menu for accounts
    submenuAccountingSetup = false;
    submenuAccountingPosting = false;
    submenuAccountingPostingList = false;
    submenuAccountingPaySlip = false;
    submenuAccountsBonusList = false;
    submenuAccountsPresentOffday = false;
    submenuAccountsNightStay = false;
    submenuAccountsOvertimeList = false;
    submenuAccountEncashmentList = false;
    submenuAccountsAdvancedPaymentList = false;
    submenuAccountsFinalSettlement = false;
    submenuAccountPaySlipMonthly = false;
    submenuAccountBonusMonthly = false;
    submenuAccountPOMonthly = false;
    submenuAccountOSMonthly = false;
    submenuAccountOTMonthly = false;
    submenuAccountLEMonthly = false;

    // sub-menu for cost-center
    submenuCostCenterSetup = false;

    // sub-menu for project-access
    submenuProjectAccess = false;
    submenuAccessList = false;

    // sub-menu for Income tax
    submenuTaxTemplate = false;
    submenuTaxTemplateList = false;
    submenuTaxCalculation = false;
    submenuTaxRecalculation = false;
    submenuTaxChallanEntry = false;
    submenuTaxChallanList = false;
    submenuTaxCertificate = false;
    submenuTaxChallanExcelCreate = false;

    constructor(
        private httpClient: HttpClient,
        private accessList: AccessListService
    ) {
        this.accessList
            .getAccessList()
            .pipe(
                map((data) => {
                    this.checkAccess(data);
                })
            )
            .subscribe();
    }

    ngOnInit() { }
    ngAfterViewInit() {
        mLayout.initAside();
    }

    checkAccess(data) {
        data.forEach((menu) => {
            if (menu.length > 0) {
                this.accessData.push(menu.menu);
                menu.submenu.forEach((item) => {
                    this.accessData.push(item.submenu);
                });
            }
        });

        //Menu Start
        if (this.accessData.includes("Master setup")) {
            this.menuMasterSetup = true;
        }
        if (this.accessData.includes("Employee")) {
            this.menuEmployee = true;
        }
        if (this.accessData.includes("Pay structure")) {
            this.menuPayStructure = true;
        }
        if (this.accessData.includes("Leave")) {
            this.menuLeave = true;
        }
        if (this.accessData.includes("Attendance")) {
            this.menuAttendance = true;
        }
        if (this.accessData.includes("Advance payment")) {
            this.menuAdvancePayment = true;
        }
        if (this.accessData.includes("Overtime")) {
            this.menuOverTime = true;
        }
        if (this.accessData.includes("Present Offday")) {
            this.menuPresentOffday = true;
        }
        if (this.accessData.includes("Night Stay")) {
            this.menuNightStay = true;
        }
        if (this.accessData.includes("Report")) {
            this.menuReport = true;
        }
        if (this.accessData.includes("Accounts")) {
            this.menuAccounting = true;
        }
        if (this.accessData.includes("Cost Center Setup")) {
            this.menuCostCenterSetup = true;
        }
        if (this.accessData.includes("Project Access")) {
            this.menuProjectAccess = true;
        }
        if (this.accessData.includes("Income Tax")) {
            this.menuIncomeTax = true;
        }
        if (this.accessData.includes("Provident Fund")) {
            this.menuProvidentFund = true;
        }

        //submenu Start

        if (this.accessData.includes("Group Setup")) {
            this.submenuGroupSetup = true;
        }
        if (this.accessData.includes("Company Setup")) {
            this.submenuCompanySetup = true;
        }
        if (this.accessData.includes("Company List")) {
            this.submenuCompanyList = true;
        }
        if (this.accessData.includes("Business Unit Setup")) {
            this.submenuBusinessUnitSetup = true;
        }
        if (this.accessData.includes("Business Unit List")) {
            this.submenuBusinessUnitList = true;
        }
        if (this.accessData.includes("Designation Setup")) {
            this.submenuDesignationSetup = true;
        }
        if (this.accessData.includes("Designation List")) {
            this.submenuDesignationList = true;
        }
        if (this.accessData.includes("Department Setup")) {
            this.submenuDepartmentSetup = true;
        }
        if (this.accessData.includes("Department List")) {
            this.submenuDepartmentList = true;
        }
        if (this.accessData.includes("Equivalent Designation Setup")) {
            this.submenuEquivalentDesignationSetup = true;
        }
        if (this.accessData.includes("Equivalent Designation List")) {
            this.submenuEquivalentDesignationList = true;
        }
        if (this.accessData.includes("Fiscal Year List")) {
            this.submenuFiscalYearList = true;
        }
        if (this.accessData.includes("Grade Setup")) {
            this.submenuGradeSetup = true;
        }
        if (this.accessData.includes("Grade List")) {
            this.submenuGradeList = true;
        }
        if (this.accessData.includes("Prefix Setup")) {
            this.submenuPrefixSetup = true;
        }
        if (this.accessData.includes("Prefix List")) {
            this.submenuPrefixList = true;
        }
        if (this.accessData.includes("Shift Setup")) {
            this.submenuShiftSetup = true;
        }
        if (this.accessData.includes("Shift List")) {
            this.submenuShiftList = true;
        }
        if (this.accessData.includes("Cost Center List")) {
            this.submenuCostCenterList = true;
        }
        if (this.accessData.includes("Bank List")) {
            this.submenuBankList = true;
        }
        if (this.accessData.includes("Branch (Bank) Setup")) {
            this.submenuBranchBankSetup = true;
        }
        if (this.accessData.includes("Branch (Bank) List")) {
            this.submenuBranchBankList = true;
        }
        if (this.accessData.includes("Work Station Setup")) {
            this.submenuWorkStationSetup = true;
        }
        if (this.accessData.includes("Work Station List")) {
            this.submenuWorkStationList = true;
        }
        if (this.accessData.includes("Employee nature type setup")) {
            this.submenuEmployeeNatureTypeSetup = true;
        }
        if (this.accessData.includes("Employee Nature Type List")) {
            this.submenuEmployeeNatureTypeList = true;
        }
        if (this.accessData.includes("Weekend setup")) {
            this.submenuWeekendSetup = true;
        }
        if (this.accessData.includes("Leave Year Setup")) {
            this.submenuLeaveYearSetup = true;
        }
        if (this.accessData.includes("Calendar Setup")) {
            this.submenuCalendarSetup = true;
        }
        if (this.accessData.includes("Absent Template")) {
            this.submenuAbsentTemplate = true;
        }
        if (this.accessData.includes("Absent Template List")) {
            this.submenuAbsentTemplateList = true;
        }
        if (this.accessData.includes("Absent Setup")) {
            this.submenuAbsentSetup = true;
        }
        if (this.accessData.includes("Holiday type setup")) {
            this.submenuHolidayTypeSetup = true;
        }
        if (this.accessData.includes("Holiday setup")) {
            this.submenuHolidaySetup = true;
        }
        if (this.accessData.includes("Holiday list")) {
            this.submenuHolidayList = true;
        }
        if (this.accessData.includes("Personal")) {
            this.submenuPersonal = true;
        }
        if (this.accessData.includes("Education Info")) {
            this.submenuEducationInfo = true;
        }
        if (this.accessData.includes("Experience Info")) {
            this.submenuExperienceInfo = true;
        }
        if (this.accessData.includes("Employee List")) {
            this.submenuEmployeeList = true;
        }
        if (this.accessData.includes("Employee Insert Excel")) {
            this.submenuInsertEmployeeExcel = true;
        }
        if (this.accessData.includes("Organization Setup")) {
            this.submenuOrganizationSetup = true;
        }
        if (this.accessData.includes("Organization List")) {
            this.submenuOrganizationList = true;
        }
        if (this.accessData.includes("Employee Transfer")) {
            this.submenuEmployeeTransfer = true;
        }
        if (this.accessData.includes("Transfer List")) {
            this.submenuTransferList = true;
        }
        if (this.accessData.includes("Employee Promotion")) {
            this.submenuEmployeePromotion = true;
        }
        if (this.accessData.includes("Promotion List")) {
            this.submenuPromotionList = true;
        }
        if (this.accessData.includes("Employee Remarks")) {
            this.submenuEmployeeRemarks = true;
        }
        if (this.accessData.includes("Employee Remarks List")) {
            this.submenuEmployeeRemarksList = true;
        }
        if (this.accessData.includes("Earning Heads")) {
            this.submenuEarningHeads = true;
        }
        if (this.accessData.includes("Earning Heads List")) {
            this.submenuEarningHeadsList = true;
        }
        if (this.accessData.includes("Deduction Heads")) {
            this.submenuDeductionHeads = true;
        }
        if (this.accessData.includes("Deduction Heads List")) {
            this.submenuDeductionHeadsList = true;
        }
        if (this.accessData.includes("Pay Structure Template")) {
            this.submenuPayStructureTemplate = true;
        }
        if (this.accessData.includes("Template List")) {
            this.submenuTemplateList = true;
        }
        if (this.accessData.includes("Pay Structure Setup")) {
            this.submenuPayStructureSetup = true;
        }
        if (this.accessData.includes("Pay Structure List")) {
            this.submenuPayStructureList = true;
        }
        if (this.accessData.includes("Pay Structure Resigned List")) {
            this.submenuPayStructureResignedList = true;
        }
        if (this.accessData.includes("Bonus Setup")) {
            this.submenuBonusSetup = true;
        }
        if (this.accessData.includes("Bonus List (Employee)")) {
            this.submenuBonusListEmployee = true;
        }
        if (this.accessData.includes("Bonus List (Project)")) {
            this.submenuBonusListProject = true;
        }
        if (this.accessData.includes("Variable Input")) {
            this.submenuVariableInput = true;
        }
        if (this.accessData.includes("Variable Input List")) {
            this.submenuVariableInputList = true;
        }
        if (this.accessData.includes("Holding Head Entry")) {
            this.submenuHoldingHeadEntry = true;
        }
        if (this.accessData.includes("Holding Head List")) {
            this.submenuHoldingHeadList = true;
        }
        if (this.accessData.includes("Pay Slip Generation")) {
            this.submenuPaySlipGeneration = true;
        }
        if (this.accessData.includes("Final Settlement")) {
            this.submenuFinalSettlement = true;
        }
        if (this.accessData.includes("Final Settlement List")) {
            this.submenuFinalSettlementList = true;
        }
        if (this.accessData.includes("Supplementary Salary")) {
            this.submenuSupplimentarySalary = true;
        }
        if (this.accessData.includes("Supplementary Salary List")) {
            this.submenuSupplimentarySalaryList = true;
        }
        if (this.accessData.includes("Leave type setup")) {
            this.submenuLeaveTypeSetup = true;
        }
        if (this.accessData.includes("Leave type list")) {
            this.submenuLeaveTypeList = true;
        }
        if (this.accessData.includes("Leave policy setup")) {
            this.submenuLeavePolicySetup = true;
        }
        if (this.accessData.includes("Leave policy list")) {
            this.submenuLeavePolicyList = true;
        }
        if (this.accessData.includes("Regular leave balance import")) {
            this.submenuRegularLeaveBalanceImport = true;
        }
        if (this.accessData.includes("Monthly leave balance import")) {
            this.submenuMonthlyLeaveBalanceImport = true;
        }
        if (this.accessData.includes("Leave application")) {
            this.submenuLeaveApplication = true;
        }
        if (this.accessData.includes("Leave Application Excel")) {
            this.submenuLeaveApplicationExcel = true;
        }
        if (this.accessData.includes("Leave application list")) {
            this.submenuLeaveApplicationList = true;
        }
        if (this.accessData.includes("Leave encashment setup")) {
            this.submenuLeaveEncashmentSetup = true;
        }
        if (this.accessData.includes("Leave encashment setup list")) {
            this.submenuLeaveEncashmentSetupList = true;
        }
        if (this.accessData.includes("Leave encashment generation")) {
            this.submenuLeaveEncashmentGeneration = true;
        }
        if (this.accessData.includes("Leave encashment history")) {
            this.submenuLeaveEncashmentHistory = true;
        }
        if (this.accessData.includes("Attendance Entry (Calendar)")) {
            this.submenuAttendanceEntryCalendar = true;
        }
        if (this.accessData.includes("Attendance History")) {
            this.submenuAttendanceHistory = true;
        }
        if (this.accessData.includes("Attendance Entry (Excel Import)")) {
            this.submenuAttendanceEntryExcelImport = true;
        }
        if (this.accessData.includes("Attendance History From Device")) {
            this.submenuAttendanceHistoryFromDevice = true;
        }
        if (this.accessData.includes("Attendance Calculation")) {
            this.submenuAttendanceCalculation = true;
        }
        if (this.accessData.includes("Outstation Entry")) {
            this.submenuOutstationEntry = true;
        }
        if (this.accessData.includes("Late Present Setup")) {
            this.submenuLatePresentSetup = true;
        }
        if (this.accessData.includes("Advance template setup")) {
            this.submenuAdvanceTemplateSetup = true;
        }
        if (this.accessData.includes("Advance Template Setup List")) {
            this.submenuAdvanceTemplateSetupList = true;
        }
        if (this.accessData.includes("Advance Payment")) {
            this.submenuAdvancePayment = true;
        }
        if (this.accessData.includes("Advance history")) {
            this.submenuAdvanceHistory = true;
        }
        if (this.accessData.includes("Monthly advance deduction")) {
            this.submenuMonthlyAdvanceDeduction = true;
        }
        if (this.accessData.includes("Early settlement")) {
            this.submenuEarlySettlement = true;
        }
        if (this.accessData.includes("Overtime Template Setup")) {
            this.submenuOvertimeTemplateSetup = true;
        }
        if (this.accessData.includes("Overtime Template Setup List")) {
            this.submenuOvertimeTemplateSetupList = true;
        }
        if (this.accessData.includes("Overtime Setup")) {
            this.submenuOvertimeSetup = true;
        }
        if (this.accessData.includes("Overtime Setup List")) {
            this.submenuOvertimeSetupList = true;
        }
        if (this.accessData.includes("Overtime entry")) {
            this.submenuOvertimeEntry = true;
        }
        if (this.accessData.includes("Overtime history")) {
            this.submenuOvertimeHistory = true;
        }
        if (this.accessData.includes("Monthly Overtime Entry")) {
            this.submenuMonthlyOvertimeEntry = true;
        }
        if (this.accessData.includes("Monthly Overtime List")) {
            this.submenuMonthlyOvertimeEntryList = true;
        }
        if (this.accessData.includes("Present Offday Template")) {
            this.submenuPresentOffdayTemplateSetup = true;
        }
        if (this.accessData.includes("Present Offday Template List")) {
            this.submenuPresentOffdayTemplateList = true;
        }
        if (this.accessData.includes("Present Off-day Setup")) {
            this.submenuPresentOffDaySetup = true;
        }
        if (this.accessData.includes("Present Off-day List")) {
            this.submenuPresentOffDayList = true;
        }
        if (this.accessData.includes("Monthly Present Offday Entry")) {
            this.submenuMonthlyPOEntry = true;
        }
        if (this.accessData.includes("Monthly Present Offday List")) {
            this.submenuMonthlyPOList = true;
        }
        if (this.accessData.includes("Offday present")) {
            this.submenuOffdayPresent = true;
        }
        if (this.accessData.includes("Offday present list")) {
            this.submenuOffdayPresentList = true;
        }
        if (this.accessData.includes("Night Stay Template")) {
            this.submenuNightStayTemplateSetup = true;
        }
        if (this.accessData.includes("Night Stay Template List")) {
            this.submenuNightStayTemplateList = true;
        }
        if (this.accessData.includes("Night Stay Setup")) {
            this.submenuNightStaySetup = true;
        }
        if (this.accessData.includes("Night Stay List")) {
            this.submenuNightStaySetupList = true;
        }
        if (this.accessData.includes("Monthly Night Stay Entry")) {
            this.submenuMonthlyOSEntry = true;
        }
        if (this.accessData.includes("Monthly Night Stay List")) {
            this.submenuMonthlyOSList = true;
        }
        if (this.accessData.includes("Employee Report")) {
            this.submenuEmployeeReport = true;
        }
        if (this.accessData.includes("Setup Report")) {
            this.submenuSetupReport = true;
        }
        if (this.accessData.includes("Entry Report")) {
            this.submenuEntryReport = true;
        }
        if (this.accessData.includes("Attendance report")) {
            this.submenuAttendanceReport = true;
        }
        if (this.accessData.includes("Habitual Report")) {
            this.submenuHabitualReport = true;
        }
        if (this.accessData.includes("Overall Report")) {
            this.submenuOverallReport = true;
        }
        if (this.accessData.includes("Central Report")) {
            this.submenuCentralReport = true;
        }
        if (this.accessData.includes("Salary TDS Report")) {
            this.submenuSalaryTdsReport = true;
        }
        if (this.accessData.includes("Personal Employee List(Report)")) {
            this.submenuPersonalEmployeeListReport = true;
        }
        if (this.accessData.includes("Organization List")) {
            this.submenuOrganizationListReport = true;
        }
        if (this.accessData.includes("Pay Structure List(Report)")) {
            this.submenuPayStructureListReport = true;
        }
        if (this.accessData.includes("Pay Slip List (Employee)")) {
            this.submenuPaySlipListEmployee = true;
        }
        if (this.accessData.includes("Pay Slip List (Monthly)")) {
            this.submenuPaySlipListMonthly = true;
        }
        if (this.accessData.includes("Pay Slip List (Work station)")) {
            this.submenuPaySlipListWorkStation = true;
        }
        if (this.accessData.includes("Salary statement for Bank")) {
            this.submenuSalaryStatementForBank = true;
        }
        if (this.accessData.includes("Salary statement for Cash")) {
            this.submenuSalaryStatementForCash = true;
        }
        if (this.accessData.includes("Variable Input Report")) {
            this.submenuVariableInputListReport = true;
        }
        if (this.accessData.includes("Leave policy list Report")) {
            this.submenuLeavePolicyListReport = true;
        }
        if (this.accessData.includes("Leave balance list Report")) {
            this.submenuLeaveBalanceListReport = true;
        }
        if (this.accessData.includes("Leave report (Details)")) {
            this.submenuLeaveReportDetails = true;
        }
        if (this.accessData.includes("Leave report (Summary)")) {
            this.submenuLeaveReportSummary = true;
        }
        if (this.accessData.includes("Leave encashment setup list Report")) {
            this.submenuLeaveEncashmentSetupListReport = true;
        }
        if (this.accessData.includes("Overtime report")) {
            this.submenuOvertimeReport = true;
        }
        if (this.accessData.includes("Advance history Report")) {
            this.submenuAdvanceHistoryReport = true;
        }
        if (this.accessData.includes("Early settlement Report")) {
            this.submenuEarlySettlementReport = true;
        }
        if (this.accessData.includes("Holiday list Report")) {
            this.submenuHolidayListReport = true;
        }
        if (this.accessData.includes("Present off day list Report")) {
            this.submenuPresentOffDayListReport = true;
        }
        if (this.accessData.includes("Transfer List Report")) {
            this.submenuTransferListReport = true;
        }
        if (this.accessData.includes("Accounting setup")) {
            this.submenuAccountingSetup = true;
        }
        if (this.accessData.includes("Accounting posting")) {
            this.submenuAccountingPosting = true;
        }
        if (this.accessData.includes("Accounting posting List")) {
            this.submenuAccountingPostingList = true;
        }
        if (this.accessData.includes("Payslip Accounts")) {
            this.submenuAccountingPaySlip = true;
        }
        if (this.accessData.includes("Bonus List (Accounts)")) {
            this.submenuAccountsBonusList = true;
        }
        if (this.accessData.includes("Present Offday List (Accounts)")) {
            this.submenuAccountsPresentOffday = true;
        }
        if (this.accessData.includes("Night Stay Accounts")) {
            this.submenuAccountsNightStay = true;
        }
        if (this.accessData.includes("Overtime List (Accounts)")) {
            this.submenuAccountsOvertimeList = true;
        }
        if (this.accessData.includes("Encashment List Accounts")) {
            this.submenuAccountEncashmentList = true;
        }
        if (this.accessData.includes("Advance Payment List (Accounts)")) {
            this.submenuAccountsAdvancedPaymentList = true;
        }
        if (this.accessData.includes("Final Settlement (Accounts)")) {
            this.submenuAccountsFinalSettlement = true;
        }
        if (this.accessData.includes("Payslip Accounts Monthly")) {
            this.submenuAccountPaySlipMonthly = true;
        }
        if (this.accessData.includes("Bonus Accounts Monthly")) {
            this.submenuAccountBonusMonthly = true;
        }
        if (this.accessData.includes("Present Offday Accounts Monthly")) {
            this.submenuAccountPOMonthly = true;
        }
        if (this.accessData.includes("Night Stay Accounts Monthly")) {
            this.submenuAccountOSMonthly = true;
        }
        if (this.accessData.includes("Overtime Accounts Monthly")) {
            this.submenuAccountOTMonthly = true;
        }
        if (this.accessData.includes("Encashment Accounts Monthly")) {
            this.submenuAccountLEMonthly = true;
        }
        if (this.accessData.includes("Cost Center Setup")) {
            this.submenuCostCenterSetup = true;
        }
        if (this.accessData.includes("Access Control")) {
            this.submenuProjectAccess = true;
        }
        if (this.accessData.includes("Access List")) {
            this.submenuAccessList = true;
        }
        if (this.accessData.includes("Project-wise Template Assign")) {
            this.submenuProjectWiseTemplateAssign = true;
        }
        if (this.accessData.includes("Denomination Master")) {
            this.submenuDenominationMaster = true;
        }
        if (this.accessData.includes("Denomination List")) {
            this.submenuDenominationList = true;
        }
        if (this.accessData.includes("Denomination Report")) {
            this.submenuDenominationReport = true;
        }
        if (this.accessData.includes("Common Report")) {
            this.submenuCommonReport = true;
        }
        if (this.accessData.includes("Renew Employee Contract")) {
            this.submenuEmployeeContractRenew = true;
        }
        if (this.accessData.includes("Project-wise All Employee list")) {
            this.submenuProjectwiseAllEmployeeList = true;
        }
        if (this.accessData.includes("Salary Holdup Employee list")) {
            this.submenuSalaryHoldupEmployeeList = true;
        }
        if (this.accessData.includes("Attrition Report")) {
            this.submenuAttritionReport = true;
        }
        if (this.accessData.includes("Organization Setup Excel")) {
            this.submenuOrganizationSetupExcel = true;
        }
        if (this.accessData.includes("Employee Update Excel")) {
            this.submenuUpdateEmployeeExcel = true;
        }
        if (this.accessData.includes("Man Power Budget")) {
            this.submenuManPowerBudget = true;
        }
        if (this.accessData.includes("Man Power Budget List")) {
            this.submenuManPowerBudgetList = true;
        }
        if (this.accessData.includes("Chart Report")) {
            this.submenuChartReport = true;
        }
        if (this.accessData.includes("Education Info Excel")) {
            this.submenuEducationInfoExcel = true;
        }
        if (this.accessData.includes("Experience Info Excel")) {
            this.submenuExperienceInfoExcel = true;
        }
        if (this.accessData.includes("Education Concentration")) {
            this.submenuEducationConcentration = true;
        }
        if (this.accessData.includes("Education Board Master")) {
            this.submenuEducationBoardMaster = true;
        }
        if (this.accessData.includes("Education Board List")) {
            this.submenuEducationBoardList = true;
        }
        if (this.accessData.includes("Education Level Master")) {
            this.submenuEducationLevelMaster = true;
        }
        if (this.accessData.includes("Education Level List")) {
            this.submenuEducationLevelList = true;
        }
        if (this.accessData.includes("Education Institute Master")) {
            this.submenuEducationInstituteMaster = true;
        }
        if (this.accessData.includes("Education Institute List")) {
            this.submenuEducationInstituteList = true;
        }
        if (this.accessData.includes("Education Exam Title Master")) {
            this.submenuEducationExamTitleMaster = true;
        }
        if (this.accessData.includes("Education Exam Title List")) {
            this.submenuEducationExamTitleList = true;
        }
        if (this.accessData.includes("Training Certification Info")) {
            this.submenuTrainingCertificationInfo = true;
        }
        if (this.accessData.includes("Bonus List Report")) {
            this.submenuBonusListReport = true;
        }
        if (this.accessData.includes("Bonus Statement For Bank")) {
            this.submenuBonusStatementForBank = true;
        }
        if (this.accessData.includes("Bonus Statement For Cash")) {
            this.submenuBonusStatementForCash = true;
        }
        if (this.accessData.includes("Pay Structure Setup Excel")) {
            this.submenuPayStructureSetupExcel = true;
        }
        if (this.accessData.includes("Tax Template")) {
            this.submenuTaxTemplate = true;
        }
        if (this.accessData.includes("Tax Template List")) {
            this.submenuTaxTemplateList = true;
        }
        if (this.accessData.includes("Tax Calculation")) {
            this.submenuTaxCalculation = true;
        }
        if (this.accessData.includes("Tax Recalculation")) {
            this.submenuTaxRecalculation = true;
        }
        if (this.accessData.includes("Tax Challan Entry")) {
            this.submenuTaxChallanEntry = true;
        }
        if (this.accessData.includes("Tax Challan List")) {
            this.submenuTaxChallanList = true;
        }
        if (this.accessData.includes("Tax Certificate")) {
            this.submenuTaxCertificate = true;
        }
        if (this.accessData.includes("Country List")) {
            this.submenuCountryList = true;
        }
        if (this.accessData.includes("Provident Fund Template")) {
            this.submenuProvidentFundTemplateSetup = true;
        }
        if (this.accessData.includes("Provident Fund Template List")) {
            this.submenuProvidentFundTemplateList = true;
        }
        if (this.accessData.includes("Provident Fund Setup")) {
            this.submenuProvidentFundSetup = true;
        }
        if (this.accessData.includes("Provident Fund Setup List")) {
            this.submenuProvidentFundSetupList = true;
        }
        if (this.accessData.includes("Provident Fund Report")) {
            this.submenuProvidentFundReport = true;
        }
        if (this.accessData.includes("Tax Challan Excel Create")) {
            this.submenuTaxChallanExcelCreate = true;
        }
        if (this.accessData.includes("Remarks Report")) {
            this.submenuRemarksReport = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.component.ts